import axios from "axios";

export default {
  state: {
    user: [],
    token: localStorage.getItem('access_token') || null,

    // cloudDomain: 'http://localhost/sofaapi/public/',
    // adminDomain: 'http://localhost/sofaapi/public/',
    // domain: 'http://localhost/sofaapi/public/api/',
    // cloudDomain: 'http://localhost/sofaapi/public/api/',
    // mainDomain: 'http://localhost/sofaapi/public/api/',

     adminDomain: 'https://api.eveli-on.com/public/api/',
    cloudDomain1: 'https://cdn.eveli-on.com/public/api/',
    domain: 'https://api.eveli-on.com/public/api/',
    cloudDomain: 'https://cdn.eveli-on.com/api/',
    mainDomain: 'https://api.eveli-on.com/public/api/',
    
    // adminDomain: 'http://localhost/sofaapi/public/api/',
    // cloudDomain1: 'http://localhost/sofaapi/public/api/',
    // domain: 'http://localhost/sofaapi/public/api/',
    // cloudDomain: 'https://cloud.perpao.com/api/',
    // mainDomain: 'http://localhost/sofaapi/public/api/',



  },

  getters: 
  {    loggedIn(state) {
    return state.token !== null
  },

},
mutations: {

  retrieveToken(state, token) {
    state.token = token
  },
  destroyToken(state) {
    state.token = null
  },
  retrieveUser(state,data) {
    state.user = data
  }

},
actions: {
 retrieveUser(context) {

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

  return new Promise((resolve, reject) => {
    axios.get(this.state.users.adminDomain+'auth/user')
    .then(response => {
      resolve(response)
      context.commit('retrieveUser', response.data)
    })
    .catch(error => {
      reject(error)
    })
  })
},
register(context, data) {
  return new Promise((resolve, reject) => {
    axios.post(this.state.users.adminDomain+'auth/signup', {
      name: data.name,
      email: data.email,
      password: data.password,
    })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
  })
},

retrieveToken(context, credentials) {

  return new Promise((resolve, reject) => {
    axios.post(this.state.users.adminDomain+'auth/login', {
      email: credentials.email,
      password: credentials.password,
    })
    .then(response => {
      const token = response.data.access_token
      alert(token)

      localStorage.setItem('access_token', token)
      context.commit('retrieveToken', token)
      resolve(response)
            // console.log(response);
            // context.commit('addTodo', response.data)
          })
    .catch(error => {
      console.log(error)
      reject(error)
    })
  })
},
destroyToken(context) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.state.token

  if (context.getters.loggedIn) {
    return new Promise((resolve, reject) => {
      axios.post(this.state.users.adminDomain+'auth/logout')
      .then(response => {
        localStorage.removeItem('access_token')
        context.commit('destroyToken')
        resolve(response)
              // console.log(response);
              // context.commit('addTodo', response.data)
            })
      .catch(error => {
        localStorage.removeItem('access_token')
        context.commit('destroyToken')
        reject(error)
      })
    })
  }
},

},
getters: {
  loggedIn(state) {
    return state.token !== null
  },

  getFilterUser(state) {
    if (state.filterUser == 'all') {
      return state.users
    } else if (state.filterUser == 'copiright') {
      return state.users.filter(item => item.status == 'copiright')
    } else if (state.filterUser == 'translater') {
      return state.users.filter(item => item.type == 'translater')
    } else if (state.filterUser == 'denied') {
      return state.users.filter(item => item.type == 'denied')
    }

  },
  getUser(state) {
    return state.user
  },
  getDomainName(state) {
    return state.domain
  },
  getAdminDomainName(state) {
    return state.adminDomain
  },
  getMainDomainName(state) {
    return state.mainDomain
  },
  getUserRole(state) {
    return state.user.role_id
  },
  getUserId(state) {
    return state.user.id
  },
  getCloudDomain(state) {
    return state.cloudDomain
  },
  getCloudDomain1(state) {
    return state.cloudDomain1
  }

}
}


// WEBPACK FOOTER //
// ./src/store/users.js